export default "__VITE_ASSET__SgihS$SN__"